<template>
  <div class="container-main">
    <bannerVideo bg="#c1bbaa" videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/content.mp4" allVideoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/content-all.mp4" title="魔法好课" message="好未来18年教研教学经验沉淀的各学科教研资料和教学方法"></bannerVideo>
    <teachMethods bg="#F8F9FD" main="18年好未来教学方法沉淀" sub="科学的教学，让老师更加得心应手" :config="methodScrollConfig"></teachMethods>
    <teachMethods main="教学全场景服务支持" sub="体系化的支持，让机构服务更加全面和高效" :config="serviceScrollConfig"></teachMethods>
    <subjectIntro bg="#F8F9FD" :hasSub="hasSub"></subjectIntro>
    <oneImg :main="imgConfig.main" :sub="imgConfig.sub" :imgUrl="imgConfig.imgUrl" :imgW="imgConfig.imgW" :imgH="imgConfig.imgH"></oneImg>
  </div>
</template>
<script>
import bannerVideo from './components/bannerVideo/bannerVideo'
import teacherTeam from './components/techerTeam'
// import hashScroll from './components/hashScroll'
import teachMethods from './components/teachMethods'
import subjectIntro from './components/subject-intro'
import oneImg from './components/oneImg'
import { methodScrollConfig, serviceScrollConfig } from '@/const/index'
export default {
  data () {
    return {
      methodScrollConfig: methodScrollConfig,
      serviceScrollConfig: serviceScrollConfig,
      hasSub: [1, 2, 3, 4, 5, 6],
      imgConfig: {
        imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/quality.png',
        imgW: 1034,
        imgH: 453,
        main: '提升机构教学质量',
        sub: '让机构老师专注于上课，扩大带班量'
      }
    }
  },
  components: { bannerVideo, teacherTeam, teachMethods, subjectIntro, oneImg }
}
</script>
